module.exports = __webpack_public_path__ + "static/media/icita2016.5c7ee15a.png";